import {getConnectedValue, updateConnectedValue} from "../../js/ConnectedStore";
import {
    Activity,
    as_allOccasions,
    as_curStepData,
    as_frontSortedActivities, as_initialConfig,
    as_result,
    FormSteps,
    InitialRequestConfig
} from "../state";
import {as_memory, as_requestPopupOpen, as_requestPopupReady} from "../../js/app";
import {getActivitiyData} from "../../js-memo/state";


export function getNextStep(curStep:number):number{
	if(curStep == FormSteps.activities && getConnectedValue(as_allOccasions).length <= 0)
		return FormSteps.location;
	return curStep + 1;
}
export function getPrevStep(curStep:number):number{
	if(curStep == FormSteps.location && getConnectedValue(as_allOccasions).length <= 0)
		return FormSteps.activities;
	return curStep - 1;
}
/**Updates initial data config for when popup opens*/
export function setInitialConfig( ic: InitialRequestConfig){
    const curConfig = getConnectedValue(as_initialConfig);
    updateConnectedValue(as_initialConfig, {...curConfig, ...ic});
}

export function openPopup(resetData:boolean = true){
	if(as_requestPopupReady.get()){
		if(resetData){
			resetPopup();
			var frontSort = [];
			//add data from memolist
			var selectedActivities = {};
			as_memory.get().forEach((e)=>{
				var act:Activity = getActivitiyData(e);
				if(!e) return;
				if(Object.keys(act.variants).length == 1)
					selectedActivities[act.id] = e.bookingID ? e.bookingID : false;
				else
					selectedActivities[act.id] = e.bookingID ? [e.bookingID] : [];
				
				frontSort.push(act.id);
			});
			
			updateConnectedValue(as_frontSortedActivities,frontSort);
            var id = getConnectedValue(as_initialConfig);
			updateConnectedValue(as_result,{
				selectedActivity: selectedActivities,
				selectedOccasion: {},
                ...id?.data || {} //add whatever was configured as initial config and will overwrite everythign else.
			});
		}
		as_requestPopupOpen.set(false);
		as_requestPopupOpen.set(true);
	}else{
		import('../RequestPopup').then((mo)=>{
			var c = (v)=> {
				openPopup(true);
				as_requestPopupReady.removeSubscriber(c);
			};
			as_requestPopupReady.subscribe(c);
		});
	}
	
}
export function closePopup(resetData:boolean = true){
	as_requestPopupOpen.set(false);
	
	setTimeout(()=>{
		resetData && resetPopup();
	},1000);
}
export function resetPopup(){
	updateConnectedValue(as_curStepData,{
		isCompleted:false,
		dispalyedStep:0,
		readyForNextStep:false
	});
	
	updateConnectedValue(as_frontSortedActivities,[]);
	
	updateConnectedValue(as_result,{
		selectedActivity: {},
		selectedOccasion: {},
        ...getConnectedValue(as_initialConfig)?.data||{}
	});
	
}